import { post, postJson, filePost, postFileDownload } from '@/utils/request';

/******** 委托录入 Start ********/
// 导入excel获取信息
export const readEntrustmentSetFromExcel = params => {
  return filePost(`/app/etmt/readEntrustmentSetFromExcel`, params);
};
// 新增/编辑委托信息
export const editEntrustmentSetJson = params => {
  return postJson(`/app/etmt/editEntrustmentSetJson`, params);
};
// 编辑委托中的特殊说明
export const editEntrustmentNote = params => {
  return post(`/app/etmt/editEntrustmentNote`, params);
};
// 获取委托信息列表
export const getEntrustmentSetList = params => {
  return post(`/app/etmt/getEntrustmentSetList`, params);
};
// 获取委托信息详情
export const getEntrustmentSet = params => {
  return post(`/app/etmt/getEntrustmentSet`, params);
};
// 删除委托信息
export const deleteEntrustmentSet = params => {
  return post(`/app/etmt/deleteEntrustmentSet`, params);
};
// 获取当前最大委托编号
export const getReportCodeMax = params => {
  return post(`/app/etmt/getReportCodeMax`, params);
};
// 提交委托集合
export const editEntrustmentSetClientSign = params => {
  return postJson(`/app/etmt/editEntrustmentSetClientSign`, params);
};
// 获取未分配的委托信息列表
export const getUndistributeEntrustmentSetList = params => {
  return post(`/app/etmt/getUndistributeEntrustmentSetList`, params);
};
// 获取已分配的委托信息列表
export const getDistributeEntrustmentSetList = params => {
  return post(`/app/etmt/getDistributeEntrustmentSetList`, params);
};
// 修改委托集合信息
export const editEntrustmentSetData = params => {
  return postJson(`/app/etmt/editEntrustmentSetData`, params);
};
/******** 委托录入 End ********/

/******** 委托协议书 Start ********/
// 列表
export const getEntrustmentList = params => {
  return post(`/app/etmt/getEntrustmentList`, params);
};
// 编辑
export const editEntrustmentJson = params => {
  return postJson(`/app/etmt/editEntrustmentJson`, params);
};
// 提交分配后添加新委托
export const addEntrustmentJson = params => {
  return postJson(`/app/etmt/addEntrustmentJson`, params);
};
// 详情
export const getEntrustment = params => {
  return post(`/app/etmt/getEntrustment`, params);
};
// 删除
export const deleteEntrustment = params => {
  return post(`/app/etmt/deleteEntrustment`, params);
};
/******** 委托协议书 End ********/

// 接样
export const editEntrustmentReceipt = params => {
  return post(`/app/etmt/editEntrustmentReceipt`, params);
};

// 上传总报告
export const editEntrustmentSetDocPath = params => {
  return post(`/app/etmt/editEntrustmentSetDocPath`, params);
};

// 上传总报告
export const editSampleInfo = params => {
  return postJson(`/app/etmt/editSampleInfo`, params);
};

// 总报告生成二维码
export const generateSetDocQRCode = params => {
  return post(`/app/etmt/generateSetDocQRCode`, params);
};
